import { Auth } from '@aws-amplify/auth'
import cx from 'classnames'
import { Link } from 'gatsby'
import { useState } from 'react'
import iconPurple from '../../images/iconPurple.svg'
import UniversalSearch from './UniversalSearch'
import { useAbilities } from './Usergroups'

export const LogoutButton = () => {
  const [submitting, setSubmitting] = useState(false)
  const { logout } = useAbilities()

  const handleClick = async () => {
    try {
      setSubmitting(true)
      await Auth.signOut()
      window.location.reload()
    } finally {
      logout()
      setSubmitting(false)
    }
  }

  return (
    <button onClick={handleClick} className={cx('button is-light', { 'is-loading': submitting })}>
      <strong>Log Out</strong>
    </button>
  )
}

const Navbar = () => {
  const [navbarMenuActive, setNavbarMenuActive] = useState(false)

  return (
    <nav className="navbar is-dark" style={{ minHeight: 'unset' }}>
      <div className="navbar-brand" style={{ minHeight: 'unset' }}>
        <Link className="navbar-item" to="/dashboard">
          <img width="20px" src={iconPurple} alt="Dashboard home" />

          <div className="navbar-item is-size-3 has-text-white">Admin</div>
        </Link>

        {/* TODO: Change to a button */}
        {/* eslint-disable jsx-a11y/anchor-is-valid */}

        <a
          role="button"
          className="navbar-burger"
          aria-label="menu"
          aria-expanded="false"
          style={{ height: 'unset' }}
          onClick={() => setNavbarMenuActive((prev) => !prev)}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      {/* eslint-enable jsx-a11y/anchor-is-valid */}

      <div className={cx('navbar-menu', { 'is-active': navbarMenuActive })}>
        <div className="navbar-end">
          <div className="navbar-item">
            <UniversalSearch />
          </div>
          <div className="navbar-item">
            <div className="buttons">
              <LogoutButton />
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
